export default function Mission() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-slate-900 mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            Mission
          </h2>
          <div className="bg-slate-50 border-l-8 border-red-800 p-10 shadow-lg">
            <p className="text-xl lg:text-2xl text-slate-800 leading-relaxed">
              The <strong>Algorithmic Consistency Initiative (ACI)</strong> is a policy research organization dedicated to preventing the automation of historical bias. We bridge the gap between technical AI alignment and civil rights law, advocating for safety standards that move beyond "data fairness" to address the fundamental risks of <strong>"Behavioral Mimicry"</strong> in critical infrastructure.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
